import React from 'react'
import { useState } from 'react';
import { FaRegMessage } from "react-icons/fa6";
import { TbBrandGoogleFilled } from "react-icons/tb";
import SmsFallback from './SmsFallback'
import RCSFallback from './RCSFallback';



function FallbackReport() {

    const [activeTab, setActiveTab] = useState("SMSCampaignReport");

    const tabList = [
        {
            id: "SMSCampaignReport", label: " SMS Fallback", icon: <FaRegMessage />
            , component: <SmsFallback />
        },
        {
            id: "RCSCamapignReport", label: "RCS Fallback", icon: <TbBrandGoogleFilled />
            , component: <RCSFallback/>
        }
        
    ];
    return (
        <>
            <div className='dark:bg-[#121519] '>
                <div className=' w-[100%] flex gap-1 px-2 pt-4  '>
                    {tabList.map((item, index) =>
                        <button
                            onClick={() => setActiveTab(item.id)}
                            className={` w-[48%] rounded-[5px]  py-2 text-[11px] font-bold flex items-center justify-center gap-1 ${activeTab === item.id ? 'bg-[#37715d] text-[#fff]' : 'bg-[#e0e0e0] text-[#333]'} `} > {item.icon}  <span className='md:block hidden'>{item.label}</span>  </button>
                    )
                    }
                </div>
                <div className="pt-4 px-2 dark:bg-[#121519]">
                    {tabList.find((t) => t.id === activeTab)?.component}
                </div>
            </div>
        </>
    )
}

export default FallbackReport
